var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-a2196abc-1209-47d0-b610-e26a885ff0d1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1440 1920",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .uuid-dc5fbcfe-7f0d-4c6d-9e14-083c2af36739 {\r\n        fill: #2c2c2c;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-dc5fbcfe-7f0d-4c6d-9e14-083c2af36739",
    d: "M1248,0H192C85.96,0,0,85.97,0,192v1536c0,106.03,85.96,192,192,192h1056c106.03,0,192-85.97,192-192V192c0-106.03-85.97-192-192-192ZM1344,1728c0,52.95-43.07,96-96,96H192c-52.93,0-96-43.05-96-96V192c0-52.95,43.07-96,96-96h1056c52.93,0,96,43.05,96,96v1536Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-dc5fbcfe-7f0d-4c6d-9e14-083c2af36739",
    d: "M642.26,639.84l-239.06,640.31h151.69l48.98-146.91h225.56l48.98,146.91h158.39l-234.23-640.31h-160.31ZM637.43,1020.94l79.69-241.88,77.77,241.88h-157.45Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAIcon);
export default __webpack_public_path__ + "static/media/AIcon.411de638665bf42f633b5478d9d680ca.svg";
export { ForwardRef as ReactComponent };